export default {"src":"/_next/static/media/LKR.1084d89f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};